import { borderRadiuses } from './BorderRadiuses/index.js';
import { lightColors, darkColors } from './Colors/index.js';
import { lightElevation, darkElevation } from './Elevation/index.js';
import { spacing } from './Spacing/index.js';
import { speed } from './Speed/index.js';
import { typography } from './Typography/index.js';
import { zIndices } from './ZIndices/index.js';

const presetTheme = {
  speed,
  spacing,
  typography,
  locale: "fa-IR",
  colors: {
    light: lightColors,
    dark: darkColors
  },
  elevation: {
    light: lightElevation,
    dark: darkElevation
  },
  zIndices,
  borderRadiuses
};

export { presetTheme };
